import AttachmentDataProvider from 'owa-service/lib/contract/AttachmentDataProvider';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import FileProviderStore from './store/schema/FileProviderStore';
import FileProviderViewState from './store/schema/FileProviderViewState';
import FileSelectionFilter from './store/schema/FileSelectionFilter';
import getProviderBrandName from './utils/getProviderBrandName';
import getStore from './store/store';
import {
    fileProviderAdded,
    fileProviderRemoved,
    providersLoaded,
} from './actions/subscribableActions';
import {
    ClientOnlyFileProviderType,
    FileProviderType,
    FileProviderViewType,
} from './utils/constants';
import { getAddedFileProviders } from './selectors/getAddedFileProviders';
import { getFileProviders } from './selectors/getFileProviders';
import { getProviderLoadState } from './selectors/getProviderLoadState';
import { LazyImport, LazyModule } from 'owa-bundling';
import { ProviderLoadStateOption } from './store/schema/ProviderLoadStateOption';
import AddableFileProviderInfo, {
    getAddableFileProviderInfo,
    createAddableFileProviderInfo,
} from 'owa-add-fileprovider/lib/utils/AddableFileProviderInfo';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "FileProviderStore", webpackPrefetch: true */ './lazyIndex')
);

// Delayed loaded imports
export const lazyLoadProviders = new LazyImport(lazyModule, m => m.loadProviders);
export const lazyRemoveFileProvider = new LazyImport(lazyModule, m => m.removeFileProvider);
export const lazyAddFileProvider = new LazyImport(lazyModule, m => m.addFileProvider);
export const lazyRemoveAndAddFileProvider = new LazyImport(
    lazyModule,
    m => m.removeAndAddFileProvider
);

// Not delay loaded types
export {
    AddableFileProviderInfo,
    AttachmentDataProvider,
    AttachmentDataProviderType,
    ClientOnlyFileProviderType,
    FileProviderViewState,
    FileSelectionFilter,
    FileProviderStore,
    FileProviderViewType,
    getAddableFileProviderInfo,
    createAddableFileProviderInfo,
    ProviderLoadStateOption,
    fileProviderAdded,
    fileProviderRemoved,
    FileProviderType,
    getProviderBrandName,
    getStore /* exported for testing */,
    getProviderLoadState,
    getAddedFileProviders,
    getFileProviders,
    providersLoaded,
};
